import {ColumnBase} from './column-base';

export class ColumnText extends ColumnBase {
    ColumnType = 'text';

    constructor(options: {} = {}) {
        super(options);
    }
}
